import React from "react";
import Card from "./Card";
import styles from "./CardContainer.module.css";
import { FaInbox } from "react-icons/fa";

export default function CardContainer({ allticketced, mantenimiento = [], usuario }) {
  // Normalize and combine records
  const regularTickets = (allticketced || []).map(t => {
    // Find all records for this same TI ticket to build the full history
    const history = (allticketced || []).filter(r => r.TicketId === t.TicketId);
    return { 
      ...t, 
      area: "Gest. TI", 
      isMto: false,
      equipo: t.Ticket?.Asignacionequipo?.Equipo?.Nombrequipo || "N/A",
      cod: t.Ticket?.Asignacionequipo?.Equipo?.cod || "N/A",
      fechaCreacion: t.Ticket?.fecha || t.fecha,
      observacionOriginal: t.Ticket?.Observacion || "",
      fullHistorial: history,
      nombreTecnico: history.slice().reverse().find(tr => tr.Usuario && tr.Usuario?.nombre !== usuario?.nombre)?.Usuario?.nombre || "Técnico TI",
      cargoUsuario: usuario?.cargo || "Usuario"
    };
  });

  const mtoRecords = (mantenimiento || []).flatMap(ticket =>
    (ticket.Ticketregistros || []).map(r => ({
      ...r,
      TicketId: ticket.id, // Mto uses 'id' instead of 'TicketId' in its root
      isMto: true,
      area: "Área Mto",
      equipo: ticket.Equipo?.Nombrequipo || "N/A",
      cod: ticket.Equipo?.cod || "N/A",
      fechaCreacion: ticket.fecha,
      observacionOriginal: ticket.Observacion || "",
      fullHistorial: ticket.Ticketregistros,
      nombreTecnico: ticket.Ticketregistros?.slice().reverse().find(tr => tr.Usuario && tr.Usuario?.nombre !== usuario?.nombre)?.Usuario?.nombre || "Técnico de Mantenimiento",
      cargoUsuario: usuario?.cargo || "Usuario"
    }))
  );

  if (regularTickets.length === 0 && mtoRecords.length === 0) {
    return (
      <div className={styles.emptyState}>
        <FaInbox className={styles.emptyIcon} />
        <h3 className={styles.emptyTitle}>Sin registros</h3>
        <p className={styles.emptySubtitle}>No hay tickets en tu historial por el momento.</p>
      </div>
    );
  }

  // Filter both lists for closed (5) or canceled (6) status
  const filteredTickets = [
    ...regularTickets.filter((ticket) => ticket.EstadoId === 5 || ticket.EstadoId === 6),
    ...mtoRecords.filter((record) => record.EstadoId === 5 || record.EstadoId === 6)
  ].sort((a, b) => new Date(b.fecha) - new Date(a.fecha));

  // Combine ALL records for history lookup in Card.js
  const allRecords = [...regularTickets, ...mtoRecords];

  return (
    <div className={styles.container}>
      {filteredTickets.map((ticket, index) => {
        if (!ticket) return null;
        return (
          <Card
            key={`${ticket.isMto ? 'mto' : 'ti'}-${ticket.id || index}`}
            ticket={{ ...ticket, nombre: usuario?.nombre }}
            allticketced={allRecords}
          />
        );
      })}
    </div>
  );
}
